import * as React from 'react';

function SvgCurrentLocation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#000"
          fillRule="nonzero"
          d="M24 0L0 10.04v1.3l9.12 3.54L12.64 24h1.3z"
        />
        <path
          fill="#FFF"
          d="M0 10.04L24 0 13.95 24h-1.31l-3.52-9.12L0 11.35v-1.31zm13.37 8.44l5.66-13.5-13.5 5.63 4.56 1.78 1.1.42.42 1.11 1.76 4.56z"
        />
      </g>
    </svg>
  );
}

export default SvgCurrentLocation;
